import { RevokeTokenButton } from 'components/system/communicationToken/RevokeTokenButton';
import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import useCurrentUser from 'mrf/utils/useCurrentUser';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";
import roles from 'role'

export default function TokenList({ match }) {
    const user = useCurrentUser();

    const {t} = useTranslation();

    const fields = [
        { name: t('Creation timestamp'), key: 'creationTimestamp', map: dateTimeFormatter },
        { name: t('Expiration timestamp'), key: 'expirationTimestamp', map: dateTimeFormatter },
        { name: t('User Name'), keys: ['user', 'fullName'] },
        { name: t('User Email'), keys: ['user', 'email'] },
        { name: t('Institution'), keys: ['institution', 'name'] },
        { name: t('Country'), keys: ['institution', 'country', 'name'] },
        { name: t('Revocation Timestamp'), key: 'revocationTimestamp', map: dateTimeFormatter },
        { name: t('Revocation User'), keys: ['revocationUser', 'fullName'] },
        {
            name: '',
            map: ({ id, userId, revocationTimestamp }) => {
                if (!revocationTimestamp & user?.id === userId || user?.roles?.includes(r => r?.role?.code === "ADMIN")) {
                    return <RevokeTokenButton id={id} />
                }
            },
            align: 'right',
        },
    ];

    return (
        <ListCRUD
            plural='communicationTokens'
            singular='communicationToken'
            fields={fields}
            match={match}
            disableViewButton
            disableEditButton
            canNew={[roles.NATIONAL_AUTHORITY]}
        />
    );
};